import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-4">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 md:text-sm">
        <li>
          <Link to="/" className="cursor-pointer transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
            {item.to ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}